import { getCharacterLevelParts } from './levels.js';
import { getMinXpForLevel } from './xp-table.js';

// A character's derived XP: the minimum XP for their level in each class
// they hold, summed. Multi-class characters pair classes and levels
// positionally (e.g. "Thief, Fighter" + "3/1" => Thief 3 + Fighter 1).
export const getCharacterTotalXp = (character) => {
  const classes = String(character?.class || '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);
  if (!classes.length) return 0;

  const levels = getCharacterLevelParts(character?.level);
  if (!levels.length) return 0;

  return classes.reduce((sum, className, index) => {
    const level = levels[index] ?? levels[levels.length - 1];
    return sum + getMinXpForLevel(className, level);
  }, 0);
};
